import React from "react"
import Link from "gatsby-link"
import AboutComponent from "../components/About"
import coolbg from "../images/cool-background.png"
import Card from "../components/Card"
import Layout from "../components/layout"

const JobsPage = () => (
  <Layout>
    <div>
      <meta name="title" content="Jobs - The Views News" />
      <meta
        name="description"
        content="Our app is a product of many creative minds coming together. If you would like to join, apply here."
      />

      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://viewsnews.co/jobs" />
      <meta property="og:title" content="Jobs - The Views News" />
      <meta
        property="og:description"
        content="Our app is a product of many creative minds coming together. If you would like to join, apply here."
      />
      <meta
        property="og:image"
        content="https://i.postimg.cc/6qs9mJ4r/Top-Shelf-Copy.jpg"
      />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://viewsnews.co/jobs" />
      <meta property="twitter:title" content="Jobs - The Views News" />
      <meta
        property="twitter:description"
        content="Our app is a product of many creative minds coming together. If you would like to join, apply here."
      />
      <meta
        property="twitter:image"
        content="https://i.postimg.cc/6qs9mJ4r/Top-Shelf-Copy.jpg"
      />
      <AboutComponent
        image="https://images.unsplash.com/photo-1541039503234-50e79a69eac3?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=2b5fe81ce4b0b0f315a1689663dbcc97&auto=format&fit=crop&w=1050&q=100"
        title="Jobs"
        text="We're a small team looking for talented designers and coders with a passion to only create exciting experiences."
      />
      <div className="Cards">
        <h2>Available Positions</h2>
        <div className="CardGroup">
          <a href="/jobs/developer/">
            <Card
              title="Developer"
              subtitle="Swift, Firebase, and React"
              image="https://dwigallery.com/imgcdn/3648/http/cdn.suwalls.com/wallpapers/vector/blue-polygon-28641-1920x1080.jpg_.jpg"
            />
          </a>
          <a href="/jobs/designer/">
            <Card
              title="Designer"
              subtitle="Sketch, Framer X, or Adobe"
              image="https://images.freecreatives.com/wp-content/uploads/2016/03/Purple-Polygon-Background.jpg"
            />
          </a>
          <a href="/jobs/marketing/">
            <Card
              title="Marketing"
              subtitle="Press Kits, Search Ads, and Social Media"
              image="https://www.setaswall.com/wp-content/uploads/2017/04/Polygon-Wallpaper-29-1728x1080.jpg"
            />
          </a>
        </div>
      </div>
      <div className="Beta">
        <h3>
          Our jobs are 100% remote so meeting deadlines is a <b>must</b>. All
          salaries will be paid in the form of equity. #StartupLife
        </h3>
      </div>
    </div>
  </Layout>
)

export default JobsPage
